import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Api from '../../../../../constants/Api';
import axiosInstance from '../../../../../services/AxiosInstance';
import CustomSelect from '../../../Forms/Element/CustomSelect';

/**
 * Componente responsável por listar os motivos.
 */
const ReasonSelect = (props) => {

  const { t } = useTranslation();
  const [entities, setEntities] = useState([]);

  function findAll() {
    axiosInstance.get(Api.sales.reason)
      .then(response => {
        let entities = [];

        for (var i = 0; i < response.data.length; i++) {
          entities.push(
            {
              value: response.data[i].id,
              label: response.data[i].name
            }
          );

          setEntities(entities);
        }
      });
  }

  useEffect(() => {
    findAll();
  }, []);

  return (
    <CustomSelect options={entities} value={props.value} onChange={props.onChange} isClearable placeholder={t("select")}/>
  )
}

export default ReasonSelect;